import { render } from "./AddPlantDashboardHeader.vue?vue&type=template&id=5b6c8885"
import script from "./AddPlantDashboardHeader.vue?vue&type=script&lang=js"
export * from "./AddPlantDashboardHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__